module.exports = __webpack_public_path__ + "4ded667616cee76fc78c31237e15d65a.svg";